import { ToastController, LoadingController, Loading, AlertController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { TotvsTranslateProvider } from '../translate/totvs-translate-provider';

@Injectable()
export class TotvsNotificationProvider {

    private loading: Loading;
    static readonly SUCCESS: number = 0;
    static readonly ERROR: number = 1;
    static readonly WARNING: number = 2;

    constructor(public toastCtrl: ToastController,
        public loadingCtrl: LoadingController,
        private _alertController: AlertController,
        private _totvsTranslate: TotvsTranslateProvider

    ) {

    }

    toast(mensagem) {

        let toast = this.toastCtrl.create({
            message: mensagem,
            duration: 3000,
            showCloseButton: true,
            closeButtonText: this._totvsTranslate.instant("TOAST.DISPENSAR")
        });

        toast.onDidDismiss(() => {
            //console.log('Dismissed toast');
        });

        toast.present();
    };

    toastWithButton(tipo: any, mensagem, descriptionButton, funcOnDismiss?: any) {

        let toast = this.toastCtrl.create({
            message: mensagem,
            duration: 15000,
            showCloseButton: true,
            closeButtonText: descriptionButton,
            cssClass: this.typeMessage(tipo)
        });

        toast.onDidDismiss(funcOnDismiss);

        toast.present();
    }

    presentLoading(_enableBackdropDismiss?: boolean) {
        if (this.loading == undefined || this.loading == null) {

            this.loading = this.loadingCtrl.create({
                content: this._totvsTranslate.instant("TOAST.AGUARDE"),
                enableBackdropDismiss: _enableBackdropDismiss
            });

            return this.loading.present();
        }
        return this.loading.present();
    }

    dismissLoading() {
        if (this.loading != undefined || this.loading != null) {
            this.loading.dismiss();

            this.loading = null;
        }
    }

    notificacionToast(tipo: any, mensagem: string) {
        let options =
        {
            0: {
                message: mensagem,
                duration: 5000,
                position: 'bottom',
                cssClass: 'successToast',
                showCloseButton: true,
                closeButtonText: this._totvsTranslate.instant('COMMON.CLOSE')

            },
            1: {
                message: mensagem,
                duration: 5000,
                position: 'bottom',
                cssClass: 'errorToast',
                showCloseButton: true,
                closeButtonText: this._totvsTranslate.instant('COMMON.CLOSE')

            },
            2: {
                message: mensagem,
                duration: 5000,
                position: 'bottom',
                cssClass: 'avisoToast',
                showCloseButton: true,
                closeButtonText: this._totvsTranslate.instant('COMMON.CLOSE')
            }
        }

        let toast = this.toastCtrl.create(options[tipo]);

        toast.present();
    }

    typeMessage(tipo) {
        let options =
        {
            0: {
                cssClass: 'successToast'
            },
            1: {
                cssClass: 'errorToast'
            },
            2: {
                cssClass: 'avisoToast'
            }
        }

        return options[tipo].cssClass;
    }

    //ALERT
    presentAlert(_title: string, _subTitle: string, _buttons: any[], _enableBackdropDismiss?: boolean) {
        let alert = this._alertController.create({
            title: _title,
            subTitle: _subTitle,
            buttons: _buttons,
            enableBackdropDismiss: _enableBackdropDismiss
        });
        alert.present();
    }

    presentPrompt(_title: string, inputs: any[], _buttons: any[], _subTitle?: string, _enableBackdropDismiss?: boolean) {
        let alert = this._alertController.create({
            title: _title,
            subTitle: _subTitle,
            inputs: inputs,
            buttons: _buttons,
            enableBackdropDismiss: _enableBackdropDismiss
        });
        alert.present();
    }



}

